<div class="container container-card">
    <div class="row mt-3 mb-3">
        <div class="col-12 txt-center">
            <h2 class="pt-15 pb-15">Profilo Utente</h2>
        </div>
    </div>

    <h4 class="mt-3 mb-5"> Dati Utente </h4>
    <div class="row mt-3 mb-3">
        <div class="col">
            <label class="bold" for="nome">Nome</label>
            <input disabled id="nome" type="text" class="form-control custom-border" [(ngModel)]="user.name" />
        </div>
        <div class="col">
            <label class="bold" for="surname">Cognome</label>
            <input disabled id="surname" type="text" class="form-control custom-border" [(ngModel)]="user.surname" />
        </div>
    </div>
    <div class="row mt-3 mb-5">
        <div class="col">
            <label class="bold" for="nome">Username</label>
            <input disabled id="nome" type="text" class="form-control custom-border" [(ngModel)]="user.username" />
        </div>
        <div class="col">
            <label class="bold" for="surname">Email</label>
            <input disabled id="surname" type="text" class="form-control custom-border" [(ngModel)]="user.email" />
        </div>
    </div>
    <h4 class="mt-3 mb-5"> Gruppi </h4>
    <div class="row mt-2">
        <div class="col-12">
            <div class="border-dotted columns-overflow">
                <ul class="ul-group">
                    <li *ngFor="let group of user.groups; let i = index">
                        <div class="group w-break-all">
                            {{group.name}}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</div>